// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=0f90e8d7-7ccd-47e8-8c52-d08a02406439";
};